import { Configuration, RedirectRequest } from '@azure/msal-browser';

export interface MsalConfigParams {
    clientId: string;
    authority: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    apiScope: string;
}

export function createMsalConfig(params: MsalConfigParams): Configuration {
    return {
        auth: {
            clientId: params.clientId,
            authority: params.authority,
            redirectUri: params.redirectUri,
            postLogoutRedirectUri: params.postLogoutRedirectUri,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false,
        },
    };
}

export function createLoginRequest(apiScope: string): RedirectRequest {
    return {
        scopes: [apiScope],
    };
}

export function createTokenRequest(apiScope: string) {
    return {
        scopes: [apiScope],
        forceRefresh: false,
    };
}
